<!--
 * @Description: 打款总金额
 * @Date: 2020-12-12 16:02:25
-->
<template>
  <div>
    <div style="color: red">
      <table-render
        ref="tableRender"
        :config="configA"
        height="15vh"
        width="80vw"
        @handleSearch="handleSearch"
      />
    </div>
    <table-render
      ref="tableRender"
      :config="config"
      height="35vh"
      width="80vw"
      @handleSearch="handleSearch"
    />
    <el-form :inline="true">
      <el-form-item style="margin-bottom:0" label="支付通道：">
        <span>{{ bankText }}</span>
      </el-form-item>
    </el-form>
    <!-- <el-row type="flex">
      <el-form :inline="true">
        <el-form-item label="核算终端结算总金额：">
          <el-input
            :value="finishSumTaskPrice | moneyFixed"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="项目支付金额（结算总价合计）：">
          <el-input :value="totalPrice | moneyFixed" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-row> -->
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import main from './config';
import { payBankFormatter } from '@/common/fields/bank';

export default {
  name: 'PriceDetail',
  props: {
    // 订单ID或者ids
    orderId: {
      type: Number,
      default: 0,
      required: false
    },
    // 1未支付-全部未支付 2未支付-部分支付 3已支付 4失效
    type: {
      type: Number,
      default: 0,
      required: true
    },
    projectName: {
      type: String
    },
    fullInfo: {
      type: Object
    }
  },
  data() {
    return {
      configA: [],
      config: null,
      getTotalPriceAjax: null, // 获取总价接口
      finishSumTaskPrice: '', //终端结算总金额合计
      totalPrice: '', //结算总价合计
      payPassagewayCode: ''
    };
  },
  components: { tableRender },
  computed: {
    bankText() {
      return payBankFormatter(this.$data);
    }
  },
  methods: {
    async handleSearch(v) {
      let { pdata } = await this.getTotalPriceAjax({
        ...v,
        costOrderId: this.orderId,
        csoCustomOrderId: this.orderId
      });
      Object.assign(this.$data, pdata);
    }
  },
  created() {
    let part = main[0];
    let partA = main[1];
    // 列表接口携带固定参数
    part.childMenu[0].defaultQuery = {
      costOrderId: this.orderId,
      csoCustomOrderId: this.orderId
    };
    this.getTotalPriceAjax = part.childMenu[0].individualAjax;
    this.config = [part];
    this.configA = [partA];
    this.configA[0].childMenu[0].list = () =>
      new Promise(resolve => {
        resolve({
          data: {
            data: {
              list: [this.fullInfo],
              status: '1'
            }
          }
        });
      });
  }
};
</script>
